import { CompanyUom } from '../types'

export const defaultCompanyUom: CompanyUom = {
  code: 'CTN',
  singular: 'Carton',
  plural: 'Cartons',
  allows_decimal: false,
}

export const getCompanyUom = (uom?: Partial<CompanyUom>): CompanyUom => ({
  ...defaultCompanyUom,
  ...uom,
})

export const quantityLabel = (uom?: Partial<CompanyUom>, quantity = 2) => {
  const resolvedUom = getCompanyUom(uom)
  return quantity === 1 ? resolvedUom.singular : resolvedUom.plural
}
